import institutionIcons from '@/assets/images/institutions';
import { ListItem, Stack, Avatar, Typography } from '@mui/material';
import { IInstitution } from '../accountTypeData';

interface InstitutionListItemProps {
  item: IInstitution;
  onClick: () => void;
}

const InstitutionListItem = ({ item, onClick }: InstitutionListItemProps) => {
  const isDisabled = item.isDisabled === true;

  return (
    <ListItem
      sx={{ p: 1, cursor: isDisabled ? 'default' : 'pointer' }}
      onClick={isDisabled ? undefined : onClick}
    >
      <Stack
        direction='row'
        alignItems='center'
        gap={2}
        width='100%'
      >
        <Avatar
          src={institutionIcons[item.value as keyof typeof institutionIcons]}
        >
          {item.label.charAt(0)}
        </Avatar>

        <Stack flexGrow={1}>
          <Typography
            sx={{
              width: '100%',
              display: 'flex',
            }}
            variant='h6'
            color={isDisabled ? 'text.disabled' : undefined}
          >
            {item.label}
          </Typography>

          {isDisabled && item.disabledMessage ? (
            <Typography
              variant='body2'
              color='text.disabled'
            >
              {item.disabledMessage}
            </Typography>
          ) : null}

          <Typography variant='body2'>{item.url}</Typography>
        </Stack>
      </Stack>
    </ListItem>
  );
};

export default InstitutionListItem;
